import {
    cleanCommonParams,
    mapAttachmentParams,
    mapStatesParams,
} from './common';

const mapImpactingPolicyParams = (
    isCreate,
    {
        states,
        expired_at,
        policies_count,
        attachment,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            impacting_policy: {
                ...cleanCommonParams(params),
                ...mapAttachmentParams(isCreate, attachment),
                ...mapStatesParams(isCreate, states),
            },
        });
    });
};

export { mapImpactingPolicyParams };
